import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const FilterButton = ({ isOpen, toggle, filters, scrubFilters, isIcon }) => {
  const validFilters = scrubFilters(filters)
  let btnClass = 'btn btn-filter'
  if (isOpen) { btnClass += ' active' }
  if (validFilters.length > 0) { btnClass += ' full' }

  return (
    <Fragment>
      {isIcon
        ? <button className={`${btnClass}`} onClick={toggle} data-cy='filter-button' type='button'>
          <span className='fas fa-filter' />
        </button>
        : <div className='col-auto'>
          <button className={`${btnClass} d-none d-md-block`} onClick={toggle} data-cy='filter-button' type='button'>
            <span className='fas fa-filter me-2' /> Filters {validFilters.length > 0 ? `(${validFilters.length})` : ''}
          </button>
          <button className={`${btnClass} d-sm-block d-md-none`} onClick={toggle} data-cy='filter-button' type='button'>
            <span className='fas fa-filter' /> {validFilters.length > 0 ? `(${validFilters.length})` : ''}
          </button>
        </div>}
    </Fragment>
  )
}

FilterButton.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  filters: PropTypes.array,
  scrubFilters: PropTypes.func,
  isIcon: PropTypes.bool
}

export default FilterButton
